// Harshada Bhavsar (21/07/2025)
// Employee Form and api
import React, { useState } from "react";
import { createEmployee } from "../../../services/employeeServices";
import "./AddEmployee.css";
import { useNavigate } from "react-router-dom";

const AddEmployee = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    employeeCode: "",
    employeeName: "",
    email: "",
    phoneNumber: "",
    department: "",
    designation: "",
  });

  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setMessage("");
    setError("");
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.employeeCode.trim())
      newErrors.employeeCode = "Employee Code is required";
    if (!formData.employeeName.trim())
      newErrors.employeeName = "Employee Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phoneNumber.trim())
      newErrors.phoneNumber = "Phone Number is required";
    if (!formData.department.trim())
      newErrors.department = "Department is required";
    if (!formData.designation.trim())
      newErrors.designation = "Designation is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");
    setError("");

    const clientErrors = validateForm();
    if (Object.keys(clientErrors).length > 0) {
      setErrors(clientErrors);
      return;
    }

    try {
      const response = await createEmployee(formData);
      const data = response.data;

      if (data.status === "Success") {
        setMessage(data.message || "Employee added successfully.");
        setFormData({
          employeeCode: "",
          employeeName: "",
          email: "",
          phoneNumber: "",
          department: "",
          designation: "",
        });
      } else {
        if (data.errors) {
          setErrors(data.errors);
        } else {
          setError(data.message || "Something went wrong.");
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        setErrors(err.response.data.errors);
      } else {
        setError(err.response?.data?.message || "Something went wrong.");
      }
    }
  };

  const handleReset = () => {
    setFormData({
      employeeCode: "",
      employeeName: "",
      email: "",
      phoneNumber: "",
      department: "",
      designation: "",
    });
    setErrors({});
    setMessage("");
    setError("");
  };

  return (
    <>
      <div className="SetuSbg"></div>
      <div className="form-over-image w-100">
        <div
          className="container p-5 my-5 shadow bg-white rounded role-form-container"
          style={{ maxWidth: "900px" }}
        >
          <div className="">
            <div className="form-header">
              <i className="bi bi-person-fill avatar-icon"></i>
              <h2 className="form-title">Add Employee</h2>
            </div>
            <hr className="text-dark" />

            {message && (
              <div className="alert alert-success text-center" role="alert">
                ✅ {message}
              </div>
            )}

            {error && (
              <div className="alert alert-danger text-center" role="alert">
                ❌ {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="row">
              {/* Employee Code */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Employee Code<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="text"
                  name="employeeCode"
                  placeholder="Employee Code"
                  value={formData.employeeCode}
                  onChange={handleChange}
                  className={`input100 form-control ${
                    errors.employeeCode ? "is-invalid" : ""
                  }`}
                />
                {errors.employeeCode && (
                  <div className="invalid-feedback">{errors.employeeCode}</div>
                )}
              </div>

              {/* Employee Name */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Employee Name<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="text"
                  name="employeeName"
                  placeholder="Employee Name"
                  value={formData.employeeName}
                  onChange={handleChange}
                  className={`input100 form-control ${
                    errors.employeeName ? "is-invalid" : ""
                  }`}
                />
                {errors.employeeName && (
                  <div className="invalid-feedback">{errors.employeeName}</div>
                )}
              </div>

              {/* Email */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Email<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`input100 form-control ${
                    errors.email ? "is-invalid" : ""
                  }`}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              {/* Phone Number */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Phone Number<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  value={formData.phoneNumber}
                  maxLength="10"
                  pattern="\d{10}"
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                      handleChange(e);
                    }
                  }}
                  className={`input100 form-control ${
                    errors.phoneNumber ? "is-invalid" : ""
                  }`}
                />
                {errors.phoneNumber && (
                  <div className="invalid-feedback">{errors.phoneNumber}</div>
                )}
              </div>

              {/* Department */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Department<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="text"
                  name="department"
                  placeholder="Department"
                  value={formData.department}
                  onChange={handleChange}
                  className={`input100 form-control ${
                    errors.department ? "is-invalid" : ""
                  }`}
                />
                {errors.department && (
                  <div className="invalid-feedback">{errors.department}</div>
                )}
              </div>

              {/* Designation */}
              <div className="form-group col-md-6 col-12 mb-3">
                <label className="form-label text-black">
                  Designation<span style={{ color: "red" }}> *</span>
                </label>
                <input
                  type="text"
                  name="designation"
                  placeholder="Designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className={`input100 form-control ${
                    errors.designation ? "is-invalid" : ""
                  }`}
                />
                {errors.designation && (
                  <div className="invalid-feedback">{errors.designation}</div>
                )}
              </div>

              {/* Submit & Reset Buttons */}
              <div className="d-flex justify-content-center form-actions">
                <button
                  type="submit"
                  className="btn btn-primary px-5 py-2 mt-4 me-3"
                >
                  Submit
                </button>
                <button
                  type="reset"
                  className="btn btn-light px-5 py-2 mt-4 me-3"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEmployee;
